import portrait from '../assets/main_page_photo.jpg';

const site = {
  name: 'Lucas Reljic-Dumont',
  shortName: 'Lucas Reljic-Dumont',
  role: 'Robotics & Autonomy Developer',
  tagline: 'Perception, computer vision and embedded autonomy on ROS 2, CUDA and NVIDIA Jetson.',
  education: 'BASc Mechatronics Engineering · University of Waterloo',
  portrait,
  portraitAlt: 'Lucas Reljic-Dumont in a blue suit, standing outside a glass-fronted campus engineering building',

  bio: [
    "I build the software and systems integration behind autonomous cars, humanoid robots, and just about anything else that moves on its own.",
  ],

  socials: [
    { id: 'github',   label: 'GitHub',   href: 'https://github.com/lucasreljic/' },
    { id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/in/lucas-reljic/' },
    { id: 'email',    label: 'Email',    href: 'mailto:lucas.reljic+Portfolio@gmail.com' },
  ],

  // Focus areas surfaced under the portrait: what a robotics recruiter screens for.
  focus: ['Perception', 'Computer Vision', 'CUDA / TensorRT', 'ROS 2', 'SLAM', 'Embedded Linux'],
};

export default site;
